<div class="w-full">
  <mat-toolbar class="flex flex-row sticky top-0">
    <span>YtDLP</span>
    <span class="flex-grow"></span>
    <a mat-button routerLink="/">Home</a>
    <a mat-button routerLink="/playlists">Playlists</a>
  </mat-toolbar>
  <div class="w-full">
    <router-outlet></router-outlet>
  </div>
</div>